"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/errors.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Ferrors.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodeToJSON = exports.errorCodeFromJSON = exports.ErrorCode = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.auth.proto';
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCOUNT_DISABLED"] = "ACCOUNT_DISABLED";
    ErrorCode["ACCOUNT_SUSPENDED"] = "ACCOUNT_SUSPENDED";
    ErrorCode["VERIFIED_PHONE_REQUIRED"] = "VERIFIED_PHONE_REQUIRED";
    ErrorCode["VERIFIED_EMAIL_REQUIRED"] = "VERIFIED_EMAIL_REQUIRED";
    ErrorCode["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    ErrorCode["MEMBERSHIP_REQUIRED"] = "MEMBERSHIP_REQUIRED";
    ErrorCode["INVALID_OIDC_TOKEN"] = "INVALID_OIDC_TOKEN";
    ErrorCode["INVALID_OIDC_DOMAIN"] = "INVALID_OIDC_DOMAIN";
    ErrorCode["INVALID_IAP_TOKEN"] = "INVALID_IAP_TOKEN";
    ErrorCode["INVALID_IAP_DOMAIN"] = "INVALID_IAP_DOMAIN";
    ErrorCode["INVALID_IAP_AUDIENCE"] = "INVALID_IAP_AUDIENCE";
    ErrorCode["RATE_LIMITED"] = "RATE_LIMITED";
    ErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    ErrorCode["INVALID_ISSUER"] = "INVALID_ISSUER";
    ErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    ErrorCode["KEY_NOT_FOUND"] = "KEY_NOT_FOUND";
    ErrorCode["UNSUPPORTED_ALGORITHM"] = "UNSUPPORTED_ALGORITHM";
    ErrorCode["INVALID_SIGNATURE"] = "INVALID_SIGNATURE";
    ErrorCode["ALGORITHM_MISMATCH"] = "ALGORITHM_MISMATCH";
    ErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
    ErrorCode["TOKEN_REQUIRED"] = "TOKEN_REQUIRED";
    ErrorCode["PROFILE_NOT_FOUND"] = "PROFILE_NOT_FOUND";
    ErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ErrorCode["DEVICE_BLOCKED"] = "DEVICE_BLOCKED";
    ErrorCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    ErrorCode["KEY_PASSWORD_INVALID"] = "KEY_PASSWORD_INVALID";
    ErrorCode["KEY_TOO_MANY_PASSWORD_ATTEMPTS"] = "KEY_TOO_MANY_PASSWORD_ATTEMPTS";
    ErrorCode["IMPERSONATION_NOT_ALLOWED"] = "IMPERSONATION_NOT_ALLOWED";
    ErrorCode["MANAGED_USER_LOGIN_NOT_ALLOWED"] = "MANAGED_USER_LOGIN_NOT_ALLOWED";
    ErrorCode["WRONG_LOGIN_FLOW"] = "WRONG_LOGIN_FLOW";
    ErrorCode["FULL_WITHDRAWAL_REQUIRED"] = "FULL_WITHDRAWAL_REQUIRED";
    ErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
function errorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'ACCOUNT_DISABLED':
            return ErrorCode.ACCOUNT_DISABLED;
        case 8:
        case 'ACCOUNT_SUSPENDED':
            return ErrorCode.ACCOUNT_SUSPENDED;
        case 1:
        case 'VERIFIED_PHONE_REQUIRED':
            return ErrorCode.VERIFIED_PHONE_REQUIRED;
        case 2:
        case 'VERIFIED_EMAIL_REQUIRED':
            return ErrorCode.VERIFIED_EMAIL_REQUIRED;
        case 3:
        case 'INSUFFICIENT_PERMISSIONS':
            return ErrorCode.INSUFFICIENT_PERMISSIONS;
        case 4:
        case 'MEMBERSHIP_REQUIRED':
            return ErrorCode.MEMBERSHIP_REQUIRED;
        case 5:
        case 'INVALID_OIDC_TOKEN':
            return ErrorCode.INVALID_OIDC_TOKEN;
        case 6:
        case 'INVALID_OIDC_DOMAIN':
            return ErrorCode.INVALID_OIDC_DOMAIN;
        case 10:
        case 'INVALID_IAP_TOKEN':
            return ErrorCode.INVALID_IAP_TOKEN;
        case 11:
        case 'INVALID_IAP_DOMAIN':
            return ErrorCode.INVALID_IAP_DOMAIN;
        case 12:
        case 'INVALID_IAP_AUDIENCE':
            return ErrorCode.INVALID_IAP_AUDIENCE;
        case 7:
        case 'RATE_LIMITED':
            return ErrorCode.RATE_LIMITED;
        case 9:
        case 'USER_NOT_FOUND':
            return ErrorCode.USER_NOT_FOUND;
        case 13:
        case 'INVALID_ISSUER':
            return ErrorCode.INVALID_ISSUER;
        case 14:
        case 'TOKEN_EXPIRED':
            return ErrorCode.TOKEN_EXPIRED;
        case 15:
        case 'KEY_NOT_FOUND':
            return ErrorCode.KEY_NOT_FOUND;
        case 16:
        case 'UNSUPPORTED_ALGORITHM':
            return ErrorCode.UNSUPPORTED_ALGORITHM;
        case 17:
        case 'INVALID_SIGNATURE':
            return ErrorCode.INVALID_SIGNATURE;
        case 18:
        case 'ALGORITHM_MISMATCH':
            return ErrorCode.ALGORITHM_MISMATCH;
        case 19:
        case 'INVALID_TOKEN':
            return ErrorCode.INVALID_TOKEN;
        case 20:
        case 'TOKEN_REQUIRED':
            return ErrorCode.TOKEN_REQUIRED;
        case 21:
        case 'PROFILE_NOT_FOUND':
            return ErrorCode.PROFILE_NOT_FOUND;
        case 22:
        case 'INVALID_CREDENTIALS':
            return ErrorCode.INVALID_CREDENTIALS;
        case 23:
        case 'DEVICE_BLOCKED':
            return ErrorCode.DEVICE_BLOCKED;
        case 24:
        case 'ACCOUNT_CLOSED':
            return ErrorCode.ACCOUNT_CLOSED;
        case 25:
        case 'KEY_PASSWORD_INVALID':
            return ErrorCode.KEY_PASSWORD_INVALID;
        case 26:
        case 'KEY_TOO_MANY_PASSWORD_ATTEMPTS':
            return ErrorCode.KEY_TOO_MANY_PASSWORD_ATTEMPTS;
        case 27:
        case 'IMPERSONATION_NOT_ALLOWED':
            return ErrorCode.IMPERSONATION_NOT_ALLOWED;
        case 28:
        case 'MANAGED_USER_LOGIN_NOT_ALLOWED':
            return ErrorCode.MANAGED_USER_LOGIN_NOT_ALLOWED;
        case 29:
        case 'WRONG_LOGIN_FLOW':
            return ErrorCode.WRONG_LOGIN_FLOW;
        case 30:
        case 'FULL_WITHDRAWAL_REQUIRED':
            return ErrorCode.FULL_WITHDRAWAL_REQUIRED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ErrorCode.UNRECOGNIZED;
    }
}
exports.errorCodeFromJSON = errorCodeFromJSON;
function errorCodeToJSON(object) {
    switch (object) {
        case ErrorCode.ACCOUNT_DISABLED:
            return 'ACCOUNT_DISABLED';
        case ErrorCode.ACCOUNT_SUSPENDED:
            return 'ACCOUNT_SUSPENDED';
        case ErrorCode.VERIFIED_PHONE_REQUIRED:
            return 'VERIFIED_PHONE_REQUIRED';
        case ErrorCode.VERIFIED_EMAIL_REQUIRED:
            return 'VERIFIED_EMAIL_REQUIRED';
        case ErrorCode.INSUFFICIENT_PERMISSIONS:
            return 'INSUFFICIENT_PERMISSIONS';
        case ErrorCode.MEMBERSHIP_REQUIRED:
            return 'MEMBERSHIP_REQUIRED';
        case ErrorCode.INVALID_OIDC_TOKEN:
            return 'INVALID_OIDC_TOKEN';
        case ErrorCode.INVALID_OIDC_DOMAIN:
            return 'INVALID_OIDC_DOMAIN';
        case ErrorCode.INVALID_IAP_TOKEN:
            return 'INVALID_IAP_TOKEN';
        case ErrorCode.INVALID_IAP_DOMAIN:
            return 'INVALID_IAP_DOMAIN';
        case ErrorCode.INVALID_IAP_AUDIENCE:
            return 'INVALID_IAP_AUDIENCE';
        case ErrorCode.RATE_LIMITED:
            return 'RATE_LIMITED';
        case ErrorCode.USER_NOT_FOUND:
            return 'USER_NOT_FOUND';
        case ErrorCode.INVALID_ISSUER:
            return 'INVALID_ISSUER';
        case ErrorCode.TOKEN_EXPIRED:
            return 'TOKEN_EXPIRED';
        case ErrorCode.KEY_NOT_FOUND:
            return 'KEY_NOT_FOUND';
        case ErrorCode.UNSUPPORTED_ALGORITHM:
            return 'UNSUPPORTED_ALGORITHM';
        case ErrorCode.INVALID_SIGNATURE:
            return 'INVALID_SIGNATURE';
        case ErrorCode.ALGORITHM_MISMATCH:
            return 'ALGORITHM_MISMATCH';
        case ErrorCode.INVALID_TOKEN:
            return 'INVALID_TOKEN';
        case ErrorCode.TOKEN_REQUIRED:
            return 'TOKEN_REQUIRED';
        case ErrorCode.PROFILE_NOT_FOUND:
            return 'PROFILE_NOT_FOUND';
        case ErrorCode.INVALID_CREDENTIALS:
            return 'INVALID_CREDENTIALS';
        case ErrorCode.DEVICE_BLOCKED:
            return 'DEVICE_BLOCKED';
        case ErrorCode.ACCOUNT_CLOSED:
            return 'ACCOUNT_CLOSED';
        case ErrorCode.KEY_PASSWORD_INVALID:
            return 'KEY_PASSWORD_INVALID';
        case ErrorCode.KEY_TOO_MANY_PASSWORD_ATTEMPTS:
            return 'KEY_TOO_MANY_PASSWORD_ATTEMPTS';
        case ErrorCode.IMPERSONATION_NOT_ALLOWED:
            return 'IMPERSONATION_NOT_ALLOWED';
        case ErrorCode.MANAGED_USER_LOGIN_NOT_ALLOWED:
            return 'MANAGED_USER_LOGIN_NOT_ALLOWED';
        case ErrorCode.WRONG_LOGIN_FLOW:
            return 'WRONG_LOGIN_FLOW';
        case ErrorCode.FULL_WITHDRAWAL_REQUIRED:
            return 'FULL_WITHDRAWAL_REQUIRED';
        case ErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.errorCodeToJSON = errorCodeToJSON;
//# sourceMappingURL=errors.js.map